import { Icon } from "@mui/material";

import AppPromoCard from "../../home/components/v2/AppPromoCard";
import "../../shared/css/ui.css";
import { Profil } from "../../shared/types/Profil";
import "../css/User.css";
import SubscriptionCard, { Receipt } from "./SubscriptionCard";

const EMAIL_INSTALL_LINK =
  "https://5f6b0c5f.sibforms.com/serve/MUIEAOPhDiIQfqR6hciMd7COdRm4KLN-lrmaheNr7gOGFYSEniGMJeYXOdjVLq2l7YJKT04Tor2o2niXW6hRclpavG1stMvbtm4Gcm17NoFGRPZTn2i65JJ6jryefn6TPBd46ObBdMFC4dFM-utsoELiVbyVVTboNf1v9Ds-6YuRcddr3PlcecAn8L9CbivBgaASHKvWWaq2jdng";

type Props = {
  mail: string;
  profils: Profil[];
  clientSecret: string;
  receipt: Receipt;
  logout?: () => void;
  onChanged: () => Promise<void>;
};

const ProfilVisual = (props: Props) => {
  const { mail, profils, receipt, clientSecret, logout, onChanged } = props;

  return (
    <div className="pf-page">
      <h1 className="pf-page__title">Mon compte</h1>

      <div className="pf-grid">
        <div className="pf-column">
          <section className="nbk-card pf-card" aria-labelledby="pf-account-title">
            <h2 id="pf-account-title" className="pf-card__title">
              <Icon aria-hidden="true">person</Icon>
              Identifiants
            </h2>
            <p className="pf-label">Adresse e-mail</p>
            <p className="pf-mail">{mail}</p>
            <button type="button" className="nbk-btn nbk-btn--ghost pf-logout" onClick={logout}>
              <Icon aria-hidden="true">logout</Icon>
              Se déconnecter
            </button>
          </section>

          <SubscriptionCard receipt={receipt} clientSecret={clientSecret} onChanged={onChanged} />
        </div>

        <div className="pf-column">
          <section className="nbk-card pf-card" aria-labelledby="pf-profiles-title">
            <h2 id="pf-profiles-title" className="pf-card__title">
              <Icon aria-hidden="true">groups</Icon>
              Profils de lecture
            </h2>
            {profils.length > 0 ? (
              <ul className="pf-profiles">
                {profils.map((p) => (
                  <li key={p.id} className="pf-profile">
                    <img
                      className="pf-profile__avatar"
                      src={`https://newbrand.s3.eu-west-3.amazonaws.com/website/profils/${p.avatar}`}
                      alt=""
                      loading="lazy"
                    />
                    <span className="pf-profile__name">{p.name}</span>
                  </li>
                ))}
              </ul>
            ) : (
              <p className="pf-detail">Aucun profil pour le moment.</p>
            )}
            <p className="pf-hint">
              <Icon aria-hidden="true">info_outline</Icon>
              Ajoutez ou modifiez les profils depuis l'application mobile.
            </p>
          </section>

          <section className="nbk-card pf-card" aria-labelledby="pf-help-title">
            <h2 id="pf-help-title" className="pf-card__title">
              <Icon aria-hidden="true">help_outline</Icon>
              Besoin d'aide ?
            </h2>
            <ul className="pf-links">
              <li>
                <a className="pf-link" href="https://www.nabook.co/faq-old/" target="_blank" rel="noopener noreferrer">
                  <Icon aria-hidden="true">quiz</Icon>
                  <span>
                    <strong>Consulter la FAQ</strong>
                    <span>Les réponses aux questions les plus fréquentes</span>
                  </span>
                  <Icon aria-hidden="true" className="pf-link__chevron">
                    open_in_new
                  </Icon>
                </a>
              </li>
              <li>
                <a className="pf-link" href="mailto:hello@nabook.co">
                  <Icon aria-hidden="true">mail_outline</Icon>
                  <span>
                    <strong>Nous contacter</strong>
                    <span>hello@nabook.co</span>
                  </span>
                  <Icon aria-hidden="true" className="pf-link__chevron">
                    chevron_right
                  </Icon>
                </a>
              </li>
            </ul>
          </section>
        </div>
      </div>

      <div className="pf-app">
        <AppPromoCard />
        <a className="pf-app__email" href={EMAIL_INSTALL_LINK} target="_blank" rel="noreferrer">
          <Icon aria-hidden="true">mail_outline</Icon>
          Recevoir le lien d'installation par e-mail
        </a>
      </div>
    </div>
  );
};

export default ProfilVisual;
